import "../styles/momsday.css";

import cherryBlossoms from "../img/momsday/cherry-blossoms.jpg";
import dianaEmblem from "../img/momsday/diana-emblem.png";
import dianaGoddess from "../img/momsday/diana-goddess.png";

import FallingPetals from "../components/momsday/FallingPetals";
import PhotoFrame from "../components/momsday/PhotoFrame";
import HeroPolaroids from "../components/momsday/HeroPolaroids";

import bilbaoImg from "../img/momsday/bilbao.jpg";
import filmeMinecraftImg from "../img/momsday/filme-minecraft.jpg";
import grupoImg from "../img/momsday/grupo.jpeg";
import morenaImg from "../img/momsday/morena.jpeg";
import picosImg from "../img/momsday/picos.jpeg";
import fofinhosImg from "../img/momsday/fofinhos.png";
import bebesImg from "../img/momsday/bebes.png";
import colherImg from "../img/momsday/colher.png";
import estilososImg from "../img/momsday/estilosos.png";


/* ── Inline Heart SVG (used in hero + footer) ── */
const HeartIcon = ({ size = 20, filled = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round"
    className="md-icon-heart md-animate-shimmer"
    style={{ color: "var(--md-blossom-deep)" }}>
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);

const MomsDay = () => (
  <main className="md-root">
    <FallingPetals />

    {/* ── HERO ─────────────────────────────────────────────── */}
    <section className="md-hero">
      {/* background polaroids — add/remove photos here freely */}
      <HeroPolaroids photos={[
        bilbaoImg,
        morenaImg,
        picosImg,
        filmeMinecraftImg,
        grupoImg,
        fofinhosImg,
      ]} />
      {/* corner blossom */}
      <img
        src={cherryBlossoms}
        alt=""
        aria-hidden="true"
        className="md-hero__corner-blossom md-animate-fade-in"
      />
      {/* goddess watermark */}
      <img
        src={dianaGoddess}
        alt="Diana, Roman goddess of the hunt"
        className="md-hero__goddess md-animate-fade-in"
        style={{ animationDelay: "400ms" }}
      />

      <div className="md-hero__content">
        <img
          src={dianaEmblem}
          alt="Crescent moon with bow and arrow — emblem of Diana"
          className="md-hero__emblem md-animate-fade-in md-animate-float"
          style={{ animationDelay: "200ms", animationFillMode: "forwards" }}
        />

        <p className="md-hero__subtitle md-animate-fade-in-up" style={{ animationDelay: "300ms" }}>
          Feliz dia da mãe,
        </p>

        <h1 className="md-hero__title md-font-display md-animate-bloom" style={{ animationDelay: "500ms" }}>
          <span className="md-text-bloom">Diana</span>
        </h1>

        <p className="md-hero__tagline md-animate-fade-in" style={{ animationDelay: "900ms" }}>
          a melhor mãe do mundo 🥰
        </p>

        <div className="md-hero__divider md-animate-fade-in" style={{ animationDelay: "1100ms" }}>
          <span className="md-hero__divider-line" />
          <HeartIcon size={20} filled />
          <span className="md-hero__divider-line" />
        </div>

        <p className="md-hero__body md-animate-fade-in-up" style={{ animationDelay: "1300ms" }}>
          Desejamos-te um dia muito bonito, tal como tornas as nossas vidas. Amamos-te muito! —{" "}
          <span className="md-font-script" style={{ fontSize: "1.5rem", color: "var(--md-blossom-deep)" }}>
            Pedro &amp; Diana
          </span>
        </p>
      </div>

      {/* scroll hint */}
      <div
        className="md-hero__scroll-hint md-animate-float md-animate-fade-in"
        style={{ animationDelay: "2000ms", animationFillMode: "forwards" }}
      >
        <span className="md-hero__scroll-label">Scroll</span>
        <div className="md-hero__scroll-line" />
      </div>
    </section>

    {/* ── GALLERY ──────────────────────────────────────────── */}
    <section className="md-gallery">
      <header className="md-gallery__header">
        <p className="md-gallery__eyebrow">Algumas memórias nossas</p>
        <h2 className="md-gallery__title md-font-display">Somos muito giros 😜</h2>
        <p className="md-gallery__desc">
          Podes clicar nas imagens para as veres melhor!
        </p>
      </header>

      <div className="md-gallery__grid">
        <PhotoFrame
          imageSrc={bilbaoImg}
          caption="Nosotros en bilbao"
          rotate="-3deg"
          delay={0}
          date="2023"
          story="Nosotros somos mucho aventureros"
        />
        <PhotoFrame
          imageSrc={morenaImg}
          caption="Morenaça 🥰🥰😍"
          rotate="3deg"
          delay={150}
          date="No calor espanhol"
          story="És muito hermosa mamã"
        />
        <PhotoFrame
          imageSrc={picosImg}
          caption="Picos da Europa"
          rotate="3deg"
          delay={150}
          date="Num dia muito chuvoso..."
          story="Mas sempre com a melhor companhia :>"
        />
        <PhotoFrame
          imageSrc={filmeMinecraftImg}
          caption="No filme do minecraft"
          rotate="3deg"
          delay={150}
          date="Em 2025"
          story="Isto é que foi dar gargalhadas"
        />
        <PhotoFrame
          imageSrc={grupoImg}
          caption="Vamos tirar uma selifee"
          rotate="3deg"
          delay={150}
          date="Numa das milhentas vezes que vemos filmes"
          story="Estamos muito giras 🥰🥰"
        />
        <PhotoFrame
          imageSrc={fofinhosImg}
          caption="Um beijinho"
          rotate="3deg"
          delay={150}
          date="Para a melhor mãe do mundo"
          story="Gosta-mos muito de ti! <3"
        />
        <PhotoFrame
          imageSrc={bebesImg}
          caption="Que grupinho"
          rotate="3deg"
          delay={150}
          date="Quando ainda eramos pequeninos"
          story="És o nosso amor!"
        />
        <PhotoFrame
          imageSrc={colherImg}
          caption=">:("
          rotate="3deg"
          delay={150}
          date="Apesar de ser muito boa pessoa"
          story="Ter que nos aturar leva toda a gente ao desespero..."
        />
        <PhotoFrame
          imageSrc={estilososImg}
          caption="Cheios de estilo"
          rotate="3deg"
          delay={150}
          date="Qualquer sitio fica bem"
          story="Se nós estivermos juntos! 🥰"
        />
      </div>
    </section>

    {/* ── LETTER ───────────────────────────────────────────── */}
    <section className="md-letter-section">
      <div className="md-letter-card">
        <div className="md-letter-card__heart-top">
          <HeartIcon size={40} filled />
        </div>

        <p className="md-letter__salutation">Querida mamã,</p>

        <div className="md-letter__body">
          <p>
            Fizemos este pequeno website para ti, para relembrar-mos algumas memórias bonitas que gostamos contigo.
            És uma pessoa muito bonita, e, do fundo do nosso coração, a melhor mãe que o mundo nos podia dar. Neste dia especial, refleti-mos e agradece-mos pela pessoa que és, pelo amor que nos dás, e pelas pessoas que nos ensinas a ser. Muito obrigado mamã, amamos-te!
          </p>
        </div>

        <p className="md-letter__sign">— Pedro &amp; Diana</p>
      </div>
    </section>

    {/* ── FOOTER ───────────────────────────────────────────── */}
    <footer className="md-footer">
      <p className="md-footer__text">
        Feito com <HeartIcon size={16} filled /> para a melhor mãe do mundo
      </p>
    </footer>
  </main>
);

export default MomsDay;
